import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { ReferenceData } from '@/lib/markdown-utils';

interface ReferenceProps {
  data: ReferenceData;
}

export function Reference({ data }: ReferenceProps) {
  const { name, url } = data;

  const handleClick = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // Truncate name for display in pill (fallback for very long names)
  const truncateName = (text: string, maxLength: number = 25): string => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength).trim() + '...';
  };

  const displayName = truncateName(name);

  const pillContent = (
    <span
      className={`
        inline-flex items-center px-1.5 py-0.5 text-xs font-normal rounded-full
        bg-blue-50 text-blue-700 hover:bg-blue-100 transition-colors duration-200
        ${url ? 'cursor-pointer hover:scale-[1.01] transform' : 'cursor-default'}
        border border-blue-200/60 shadow-none
        leading-none align-middle mx-0.5
        max-w-[120px]
      `}
      onClick={handleClick}
      style={{ fontSize: '0.625rem', lineHeight: '1' }}
      title={name}
    >
      <span className="truncate block">
        {displayName}
      </span>
    </span>
  );

  const tooltipContent = name;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {pillContent}
      </TooltipTrigger>
      <TooltipContent>
        <p className="max-w-xs text-center break-words">{tooltipContent}</p>
      </TooltipContent>
    </Tooltip>
  );
}